import React, { Component, Fragment } from 'react';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { AlertHelpDialog } from '@iris-platform/iris-react-ui';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { withApollo } from 'react-apollo';
import Divider from '@material-ui/core/Divider';
import { stylesToPropType } from '../../utils';
import applicationPropType from './applicationPropType';
import ApnCertKey from './Notifications/apnCertKey';
import ApnTokenAuth from './Notifications/apnTokenAuth';
import Fgcm from './Notifications/fgcm';
import Helpfile from './helpfile.json';

const styles = () => ({
  root: {},
  icon: {
    // margin: theme.spacing.unit,
    fontSize: 14,
    cursor: 'pointer',
  },
  iconbutton: {
    width: '18px',
    height: '18px',
  },
});

class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  handleHelpOpen = (title, content) => {
    this.setState({
      open: true,
      dialogTitle: title,
      dialogContent: content,
    });
  };

  handleHelpClose = () => {
    this.setState({
      open: false,
      dialogTitle: '',
      dialogContent: '',
    });
  };

  render() {
    const { classes, application } = this.props;
    const {
      open,
      dialogTitle,
      dialogContent,
    } = this.state;
    const help = Helpfile.notifications;

    return (
      <Fragment>
        <Typography
          component="div"
          variant="subheading"
          gutterBottom
        >
          Notification Keys
          <IconButton className={classes.iconbutton} aria-label="Delete" onClick={() => this.handleHelpOpen(help.notificationKeys.title, help.notificationKeys.content)}>
            <HelpOutlineIcon className={classes.icon} />
          </IconButton>
        </Typography>
        <Typography color="textSecondary">
            To register APN/GSM keys with Notification Manager upload keys and press register button. To change keys simply upload new keys again.
        </Typography>
        <Typography color="textSecondary">
          Note that for APN you need to provide the certificate and key in pem format. You can convert your keys with the following commands:
        </Typography>
        <Typography color="textSecondary">
          <li>
          $ openssl x509 -in cert.cer -inform DER -outform PEM -out apns-cert.pem
          </li>
          <li>
          $ openssl pkcs12 -in key.p12 -out apns-key.pem -nodes
          </li>
        </Typography>
        <ApnCertKey
          appType={application.appType}
          childAppName={application.childAppName}
          domain={application.domain}
        />
        <br />
        <Divider text="OR" />
        <ApnTokenAuth
          appType={application.appType}
          childAppName={application.childAppName}
          domain={application.domain}
        />
        <br />
        <Divider />
        <Fgcm
          appType={application.appType}
          childAppName={application.childAppName}
          domain={application.domain}
        />
        <AlertHelpDialog
          handleClose={this.handleHelpClose}
          open={open}
          dialogTitle={dialogTitle}
          dialogContent={dialogContent}
        />
      </Fragment>
    );
  }
}

Register.propTypes = {
  application: applicationPropType.isRequired,
  classes: stylesToPropType(styles()).isRequired,
};

export default withStyles(styles)(withApollo(Register));
